import React from 'react';
import { Modal } from '../../components';
import SectionContactForm from '../ListingPage/SectionContactForm';
import css from './SellerContactModal.module.css';

/**
 * SellerContactModal
 *
 * Opens a brand-styled modal with the existing SectionContactForm (Dutch labels via nl.json).
 * Submission calls sendSellerContact duck action → POST users/{userId}/contact.
 */
const SellerContactModal = props => {
  const {
    isOpen,
    onClose,
    onManageDisableScrolling,
    onSubmit,
    onResetContact,
    displayName,
    inProgress,
    ready,
    error,
  } = props;

  return (
    <Modal
      id="SellerContactModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      contentClassName={css.modalContent}
    >
      <div className={css.formWrapper}>
      <SectionContactForm
        formId="sellerContact"
        onSubmit={onSubmit}
        onResetInquiry={onResetContact}
        providerName={displayName}
        inProgress={inProgress}
        ready={ready}
        error={error}
      />
      </div>
    </Modal>
  );
};

export default SellerContactModal;
